import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import {
  exchangeCodeForToken,
  gitlabConfigQueries,
} from '@/lib/queries/integrations/scm/gitlab';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { GitlabInstallationPending } from './-components/GitlabInstallationPending';

export const Route = createFileRoute('/gitlab-callback/authenticated')({
  component: GitlabInstallationPending,
  validateSearch: (search: Record<string, unknown>) =>
    z
      .object({
        code: z.coerce.string(),
        state: z.string().optional(),
      })
      .parse(search),
  loaderDeps: ({ search }) => ({ code: search.code }),
  loader: async ({ context, deps: { code } }) => {
    const defaultProject = await preLoadDefaultProject({ context });

    try {
      await exchangeCodeForToken(defaultProject.id, code);

      // Invalidate GitLab configs cache to show the new configuration
      await context.queryClient.invalidateQueries({
        queryKey: gitlabConfigQueries.all(),
      });

      // Also ensure the specific project query is invalidated
      await context.queryClient.invalidateQueries({
        queryKey: ['gitlab-configs', defaultProject.id],
      });

      // Use window.location.href to bypass navigation guards, just like GitHub does
      window.location.href = '/integrations?gitlab=installed';
    } catch (e) {
      console.error(e);
      context.toast({
        title: 'gitlabCallback.authenticationError',
        variant: 'destructive',
      });

      throw redirect({ to: '/' });
    }
  },
  pendingComponent: GitlabInstallationPending,
});
